import { defineTool } from '../../canvas/tooling/ToolDefinition';
import { createGraphicFromPopup } from './GraphicCommands';

export const graphicTool = defineTool({
    id: 'graphicTool',
    label: 'Images',
    category: 'design',
    icon: 'deqo://icons/d2/image',
    weight: 1040,
    shortcut: 'I',
    command: createGraphicFromPopup,
});
